import React from 'react';
import 'core-js/stable/array';
import 'core-js/stable/map';
import 'core-js/stable/number';
import 'core-js/stable/object';
import 'core-js/stable/promise';
import 'core-js/stable/set';
import 'core-js/stable/string';
import 'core-js/stable/symbol';
import 'core-js/stable/url-search-params';
import 'core-js/stable/weak-map';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Entry from './entry';
import routes from './routes';
import './utils/remove-polyfill';

const container = document.getElementById('root');
// @ts-ignore
const root = createRoot(container);

const router = createBrowserRouter([
    {
        path: '/',
        element: <Entry />,
        children: routes
    }
]);

root.render(<RouterProvider router={router} />);

// ReactDOM.render(<Entry />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
